"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_STATE = exports.TimeOutCountDown = exports.TimeOutType = void 0;
var TimeOutType;
(function (TimeOutType) {
    TimeOutType["ExpiredTimeOut"] = "ExpiredTimeOut";
    TimeOutType["WarningTimeOut"] = "WarningTimeOut";
})(TimeOutType || (exports.TimeOutType = TimeOutType = {}));
var TimeOutCountDown;
(function (TimeOutCountDown) {
    TimeOutCountDown[TimeOutCountDown["LAST_MINUTE"] = 60] = "LAST_MINUTE";
    TimeOutCountDown[TimeOutCountDown["UNITIALIZED"] = -1] = "UNITIALIZED";
    TimeOutCountDown[TimeOutCountDown["AT_ZERO"] = 0] = "AT_ZERO";
})(TimeOutCountDown || (exports.TimeOutCountDown = TimeOutCountDown = {}));
exports.INITIAL_STATE = {
    countDown: -1,
    isExpired: false,
    isWarning: false,
};
//# sourceMappingURL=types.js.map